import '../public-path';

import(/* webpackChunkName: "sdk-bootstrap" */'@bingads-webui-campaign-react/sdk-bootstrap').then(({ sdkBootstrap }) => {
  sdkBootstrap(window.serverContext, () => import(/* webpackMode: 'eager' */'../bootstrap'));
});
